<script setup lang="ts">
/**
 * NavigationStats — Speed, align time, agility, warp speed
 */
import type { NavigationStats as NavigationStatsType } from '../../../shared/types';

const props = defineProps<{
  navigation: NavigationStatsType;
}>();

function fmt(n: number): string {
  if (n >= 10000) return (n / 1000).toFixed(1) + 'K';
  return n.toFixed(1);
}
</script>

<template>
  <div class="nav-stats">
    <div class="nav-row">
      <span class="nav-label">Max Velocity</span>
      <span class="nav-value">{{ fmt(props.navigation.maxVelocity) }} m/s</span>
    </div>
    <div class="nav-row">
      <span class="nav-label">Align Time</span>
      <span class="nav-value">{{ props.navigation.alignTime.toFixed(2) }}s</span>
    </div>
    <div class="nav-row">
      <span class="nav-label">Agility</span>
      <span class="nav-value">{{ props.navigation.agility.toFixed(3) }}</span>
    </div>
    <div class="nav-row">
      <span class="nav-label">Warp Speed</span>
      <span class="nav-value">{{ props.navigation.warpSpeed.toFixed(1) }} AU/s</span>
    </div>
    <div class="nav-row" v-if="props.navigation.propModActive">
      <span class="nav-label">Prop Mod</span>
      <span class="nav-value prop-active">Active</span>
    </div>
  </div>
</template>

<style scoped>
.nav-stats {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.nav-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px 0;
}

.nav-label {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.nav-value {
  font-size: 0.88rem;
  font-weight: 500;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.prop-active {
  color: var(--accent-green);
  font-weight: 600;
}
</style>
